"use client"

import { Globe } from "lucide-react"
import US from "country-flag-icons/react/3x2/US"
import CA from "country-flag-icons/react/3x2/CA"
import MX from "country-flag-icons/react/3x2/MX"
import BR from "country-flag-icons/react/3x2/BR"
import CO from "country-flag-icons/react/3x2/CO"
import GY from "country-flag-icons/react/3x2/GY"
import BS from "country-flag-icons/react/3x2/BS"
import PA from "country-flag-icons/react/3x2/PA"
import UY from "country-flag-icons/react/3x2/UY"
import CL from "country-flag-icons/react/3x2/CL"
import CR from "country-flag-icons/react/3x2/CR"
import AR from "country-flag-icons/react/3x2/AR"
import DO from "country-flag-icons/react/3x2/DO"
import TT from "country-flag-icons/react/3x2/TT"
import AT from "country-flag-icons/react/3x2/AT"
import BE from "country-flag-icons/react/3x2/BE"
import CZ from "country-flag-icons/react/3x2/CZ"
import DK from "country-flag-icons/react/3x2/DK"
import DE from "country-flag-icons/react/3x2/DE"
import HU from "country-flag-icons/react/3x2/HU"
import IE from "country-flag-icons/react/3x2/IE"
import IS from "country-flag-icons/react/3x2/IS"
import IT from "country-flag-icons/react/3x2/IT"
import LU from "country-flag-icons/react/3x2/LU"
import NL from "country-flag-icons/react/3x2/NL"
import NO from "country-flag-icons/react/3x2/NO"
import PL from "country-flag-icons/react/3x2/PL"
import SK from "country-flag-icons/react/3x2/SK"
import ES from "country-flag-icons/react/3x2/ES"
import SE from "country-flag-icons/react/3x2/SE"
import CH from "country-flag-icons/react/3x2/CH"
import GB from "country-flag-icons/react/3x2/GB"
import FI from "country-flag-icons/react/3x2/FI"
import SC from "country-flag-icons/react/3x2/SC"
import MU from "country-flag-icons/react/3x2/MU"
import GA from "country-flag-icons/react/3x2/GA"
import GQ from "country-flag-icons/react/3x2/GQ"
import EG from "country-flag-icons/react/3x2/EG"
import BW from "country-flag-icons/react/3x2/BW"
import DZ from "country-flag-icons/react/3x2/DZ"
import ZA from "country-flag-icons/react/3x2/ZA"
import LY from "country-flag-icons/react/3x2/LY"
import TN from "country-flag-icons/react/3x2/TN"
import SZ from "country-flag-icons/react/3x2/SZ"
import NA from "country-flag-icons/react/3x2/NA"
import CV from "country-flag-icons/react/3x2/CV"
import MA from "country-flag-icons/react/3x2/MA"
import AO from "country-flag-icons/react/3x2/AO"
import AE from "country-flag-icons/react/3x2/AE"
import SA from "country-flag-icons/react/3x2/SA"
import QA from "country-flag-icons/react/3x2/QA"
import BH from "country-flag-icons/react/3x2/BH"
import KW from "country-flag-icons/react/3x2/KW"
import IL from "country-flag-icons/react/3x2/IL"
import TR from "country-flag-icons/react/3x2/TR"
import OM from "country-flag-icons/react/3x2/OM"
import AZ from "country-flag-icons/react/3x2/AZ"
import LB from "country-flag-icons/react/3x2/LB"
import JO from "country-flag-icons/react/3x2/JO"
import IR from "country-flag-icons/react/3x2/IR"
import IQ from "country-flag-icons/react/3x2/IQ"
import AU from "country-flag-icons/react/3x2/AU"
import NZ from "country-flag-icons/react/3x2/NZ"
import PW from "country-flag-icons/react/3x2/PW"
import NR from "country-flag-icons/react/3x2/NR"
import FJ from "country-flag-icons/react/3x2/FJ"
import TV from "country-flag-icons/react/3x2/TV"
import TO from "country-flag-icons/react/3x2/TO"
import WS from "country-flag-icons/react/3x2/WS"
import MH from "country-flag-icons/react/3x2/MH"
import FM from "country-flag-icons/react/3x2/FM"
import KI from "country-flag-icons/react/3x2/KI"
import VU from "country-flag-icons/react/3x2/VU"
import PG from "country-flag-icons/react/3x2/PG"
import SB from "country-flag-icons/react/3x2/SB"
import CN from "country-flag-icons/react/3x2/CN"
import FR from "country-flag-icons/react/3x2/FR"
import JP from "country-flag-icons/react/3x2/JP"
import KR from "country-flag-icons/react/3x2/KR"
import IN from "country-flag-icons/react/3x2/IN"
import RU from "country-flag-icons/react/3x2/RU"
import NG from "country-flag-icons/react/3x2/NG"
import PE from "country-flag-icons/react/3x2/PE"
import GR from "country-flag-icons/react/3x2/GR"
import RO from "country-flag-icons/react/3x2/RO"
import TH from "country-flag-icons/react/3x2/TH"
import VN from "country-flag-icons/react/3x2/VN"
import PH from "country-flag-icons/react/3x2/PH"
import ID from "country-flag-icons/react/3x2/ID"
import MY from "country-flag-icons/react/3x2/MY"
import SG from "country-flag-icons/react/3x2/SG"
import PK from "country-flag-icons/react/3x2/PK"
import BD from "country-flag-icons/react/3x2/BD"
import UA from "country-flag-icons/react/3x2/UA"
import PT from "country-flag-icons/react/3x2/PT"
import HR from "country-flag-icons/react/3x2/HR"
import RS from "country-flag-icons/react/3x2/RS"
import BG from "country-flag-icons/react/3x2/BG"
import SI from "country-flag-icons/react/3x2/SI"
import LT from "country-flag-icons/react/3x2/LT"
import LV from "country-flag-icons/react/3x2/LV"
import EE from "country-flag-icons/react/3x2/EE"
import CY from "country-flag-icons/react/3x2/CY"
import MT from "country-flag-icons/react/3x2/MT"
import GE from "country-flag-icons/react/3x2/GE"
import KE from "country-flag-icons/react/3x2/KE"
import GH from "country-flag-icons/react/3x2/GH"
import TZ from "country-flag-icons/react/3x2/TZ"
import ET from "country-flag-icons/react/3x2/ET"
import KH from "country-flag-icons/react/3x2/KH"
import MM from "country-flag-icons/react/3x2/MM"
import LK from "country-flag-icons/react/3x2/LK"
import NP from "country-flag-icons/react/3x2/NP"
import MN from "country-flag-icons/react/3x2/MN"
import TW from "country-flag-icons/react/3x2/TW"
import HK from "country-flag-icons/react/3x2/HK"
import MO from "country-flag-icons/react/3x2/MO"

// 国旗组件映射
export const flagComponents: Record<string, React.ComponentType<{ className?: string; title?: string }>> = {
  // Americas
  US, CA, MX, BR, CO, GY, BS, PA, UY, CL, CR, AR, DO, TT, PE,
  // Europe
  AT, BE, CZ, DK, DE, HU, IE, IS, IT, LU, NL, NO, PL, SK, ES, SE, CH, GB, FI,
  FR, GR, RO, PT, HR, RS, BG, SI, LT, LV, EE, CY, MT, UA,
  // Africa
  SC, MU, GA, GQ, EG, BW, DZ, ZA, LY, TN, SZ, NA, CV, MA, AO, NG, KE, GH, TZ, ET,
  // Middle East
  AE, SA, QA, BH, KW, IL, TR, OM, AZ, LB, JO, IR, IQ, GE,
  // Asia
  CN, JP, KR, IN, RU, TH, VN, PH, ID, MY, SG, PK, BD, KH, MM, LK, NP, MN, TW, HK, MO,
  // Oceania
  AU, NZ, PW, NR, FJ, TV, TO, WS, MH, FM, KI, VU, PG, SB,
}

interface CountryFlagProps {
  countryCode: string
  className?: string
}

export function CountryFlag({ countryCode, className = "w-5 h-4" }: CountryFlagProps) {
  // 保护：如果 countryCode 未定义，显示 Globe 图标
  if (!countryCode || countryCode === "ROW") {
    return <Globe className={className} />
  }

  const FlagComponent = flagComponents[countryCode]

  // 未找到国旗
  if (!FlagComponent) {
    return <span className={`${className} inline-flex items-center justify-center bg-gray-200 text-xs font-medium rounded-sm`}>{countryCode}</span>
  }

  return <FlagComponent className={className} title="" />
}
